import React from 'react'
import { useParams } from 'react-router-dom'
import BranchDetail from './BranchDetail'

const BranchDetailWrapper = (props) => {
    const params = useParams()
    return <BranchDetail {...props} params={params} />
}

export default BranchDetailWrapper
